import axios from "axios";
import { createAsyncThunk } from "@reduxjs/toolkit";

const PUBLIC_BASE_URL = process.env.REACT_APP_PUBLIC_BASE_URL;

const axiosConfig = {
    headers: {
        "Content-Type": "application/json",
    },
    withCredentials: true,
};

const handleAxiosError = (err, rejectWithValue) => {
    if (err.message === "Network Error") {
        return rejectWithValue({ message: "Network Error" });
    }
    return rejectWithValue(
        err.response?.data || { message: "Something went wrong" }
    );
};

export const getAllMakes = createAsyncThunk(
    "make/getAllMakes",
    async ({ skip, limit, search, status }, { rejectWithValue }) => {
        try {

            const params = {
                ...(skip != null && { skip }),
                ...(limit != null && { limit }),
                ...(search?.trim() && { search }),
                ...(status && { status }),
            };

            const response = await axios.get(
                `${PUBLIC_BASE_URL}/make`,
                {
                    ...axiosConfig,
                    params,
                }
            );
            return response.data;
        } catch (err) {
            return handleAxiosError(err, rejectWithValue);
        }
    }
);
